export const FIELD_NAMES = {
    NOTIFICATION_CONTACTS: 'notificationContacts',
    KLICKLY_EMAIL: 'klicklyEmail',
    VALUE_TYPE: 'valueType',
    VALUE: 'value',
    NOTIFY_ON_ACTIONS: 'notifyOnActions'
};
